(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["alr-card-info"] && !Shopify.designMode) return;
  try {
    (() => {
    const cache = new Map();
    const load = (handle) => {
      if (!cache.has(handle)) {
        cache.set(
          handle,
          fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`)
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        );
      }
      return cache.get(handle);
    };
    const fill = async (el) => {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';
      const current = el.dataset.current;
      const handles = el.dataset.handles.split(',').filter(Boolean);
      const box = el.querySelector('.alr-card__thumbs');
      const products = await Promise.all(handles.map(load));
      const links = [];
      products.forEach((p, i) => {
        if (!p || !p.featured_image) return;
        const a = document.createElement('a');
        a.href = p.url;
        a.title = p.title;
        if (handles[i] === current) a.setAttribute('aria-current', 'true');
        const img = document.createElement('img');
        const src = p.featured_image.startsWith('//') ? `https:${p.featured_image}` : p.featured_image;
        img.src = src + (src.includes('?') ? '&' : '?') + 'width=96';
        img.alt = p.title;
        img.loading = 'lazy';
        img.width = 44;
        img.height = 44;
        a.append(img);
        links.push(a);
      });
      if (links.length < 2) {
        el.remove();
        return;
      }
      const max = window.matchMedia('(max-width: 749px)').matches ? 4 : 5;
      let shown = links;
      if (links.length > max) {
        const cur = links.find((a) => a.hasAttribute('aria-current'));
        shown = links.filter((a) => a !== cur).slice(0, max - 2);
        if (cur) shown.unshift(cur);
        else shown = links.slice(0, max - 1);
        const more = document.createElement('a');
        more.className = 'alr-card__more';
        more.href = cur ? cur.href : links[0].href;
        more.textContent = `+${links.length - shown.length}`;
        more.setAttribute('aria-label', `Încă ${links.length - shown.length} opțiuni`);
        shown.push(more);
      }
      box.replaceChildren(...shown);
    };
    const io =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                if (e.isIntersecting) {
                  io.unobserve(e.target);
                  fill(e.target);
                }
              });
            },
            { rootMargin: '300px' }
          )
        : null;
    const scan = (root = document) => {
      root.querySelectorAll('[data-alr-sw]:not([data-loaded])').forEach((el) => (io ? io.observe(el) : fill(el)));
    };
    scan();
    new MutationObserver(() => scan()).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["proveni-surori"] && !Shopify.designMode) return;
  try {
    // Cu „Fără reîncărcare”: pagina surorii se aduce în fundal (Section Rendering API) și înlocuiește doar secțiunea
  // produsului; adresa și titlul paginii se schimbă ca la o pagină nouă. Linkul rămâne adevărat: la orice eroare
  // (sau cu Ctrl/Cmd apăsat) browserul deschide pagina obișnuit.
  if (!customElements.get('proveni-surori')) {
    customElements.define(
      'proveni-surori',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.#laClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.#laClick);
        }

        #laClick = async (event) => {
          const link = event.target.closest('a[data-proveni-sora]');
          if (!link || !this.hasAttribute('data-fara-reincarcare')) return;
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          if (link.getAttribute('aria-current') === 'page') return;

          const idSectiune = this.dataset.sectionId;
          const sectiune = document.getElementById(`shopify-section-${idSectiune}`);
          if (!sectiune) return (window.location.href = link.href);

          this.setAttribute('aria-busy', 'true');
          try {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('section_id', idSectiune);
            const raspuns = await fetch(url, { credentials: 'same-origin' });
            if (!raspuns.ok) throw new Error(String(raspuns.status));
            const doc = new DOMParser().parseFromString(await raspuns.text(), 'text/html');
            const noua = doc.getElementById(`shopify-section-${idSectiune}`);
            if (!noua) throw new Error('secțiunea lipsește');
            sectiune.innerHTML = noua.innerHTML;
            window.history.pushState({ proveniSurori: true }, '', link.href);
            if (link.dataset.titlu) document.title = link.dataset.titlu;
          } catch (eroare) {
            window.location.href = link.href;
          }
        };
      }
    );

    // înapoi/înainte după o schimbare fără reîncărcare: pagina se încarcă din nou, la adresa corectă
    window.addEventListener('popstate', (event) => {
      if (event.state && event.state.proveniSurori) window.location.reload();
    });
    if (!window.history.state) window.history.replaceState({ proveniSurori: true }, '');
  }
  } catch(e) { console.error(e); }
})();

})();
